<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="500" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-6 Reset Password
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.pa-6
      v-form(ref="form")
        div.text-sm.font-semibold.neutral500--text {{ $t('email') }}
        v-text-field.text-sm.mt-2.round-xl(v-model="email" :placeholder="$t('email')" outlined dense height="48" hide-details="auto" readonly)
        div.text-sm.font-semibold.neutral500--text.mt-4 New password
        v-text-field.text-sm.mt-2.round-xl(v-model="password" placeholder="New password" outlined dense height="48" :rules="rules.password" :type="passwordType" hide-details="auto")
          template(#append)
            v-btn(icon small style="margin-top: 2px;" @click="changePasswordType(passwordType)")
              v-icon(color="neutral500") {{ passwordType === 'text' ? 'mdi-eye-off' : 'mdi-eye' }}
        div.text-sm.font-semibold.neutral500--text.mt-4 Confirm password
        v-text-field.text-sm.mt-2.round-xl(v-model="confirmPassword" placeholder="Confirm password" outlined dense height="48" :rules="rules.confirm_password" :type="passwordType" hide-details="auto")
          template(#append)
            v-btn(icon small style="margin-top: 2px;" @click="changePasswordType(passwordType)")
              v-icon(color="neutral500") {{ passwordType === 'text' ? 'mdi-eye-off' : 'mdi-eye' }}
        div.text-sm.font-semibold.neutral500--text.mt-4 Verification code
        v-text-field.text-sm.mt-2.round-xl(v-model="verificationCode" placeholder="6 digit code" background-color="neutral100" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
          template(#append)
            y-button(:label="codeTimer > 0 ? `Resend code ${codeTimer}` : 'Request code'" size="xs" @click="requestCode" :disabled="codeTimer > 0")
          
    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="closeDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed @click="saveData" :loading="isLoading") {{ $t('save') }}
      

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      password: null,
      confirmPassword: null,
      verificationCode: null,
      codeTimer: 0,
      passwordType: 'text',
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
        password: [(v) => (v != null && v.toString().trim().length) || 'This field is required', (v) => (v != null && v.length >= 8) || 'Password must be at least 8 characters long'],
        confirm_password: [v => !!v || 'This field is required', v => v === this.password || 'Passwords do not match'],
        email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
  },
  methods: {
    ...mapActions(['showMessage']),
    requestCode () {
      this.$axios.post('/users/send_verification_code/', { email: this.email })
        .then(() => {
          this.showMessage(['info', this.$t('info_message.confirmation_code_sent_to', { text: this.email })])
          this.codeTimer = 30
          const timer = setInterval(() => {
            this.codeTimer--
            if (this.codeTimer <= 0) {
              clearInterval(timer)
            }
          }, 1000)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_send_confirmation')])
        })
    },
    changePasswordType (type) {
      if (type === 'text') {
        this.passwordType = 'password'
      } else {
        this.passwordType = 'text'
      }
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let data = {
        email: this.email,
        code: this.verificationCode
      }
      this.$axios.post(`/users/check_verification_code`, data)
        .then(() => {
          let data2 = {
            email: this.email,
            password: this.password,
            code: this.verificationCode
          }
          this.$axios.post(`/users/reset_password`, data2)
            .then(() => {
              this.showMessage(['success', 'Reset password successful'])
              this.$emit('reset')
            })
            .catch(err => {
              let message = this.$t('error_message.unable_to_complete_request')
              if (err.response.data[0]) {
                message = err.response.data[0]
              }
              this.showMessage(['error', message])
            })
            .finally(() => {
              this.isLoading = false
            })
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data[0]) {
            message = err.response.data[0]
          }
          this.showMessage(['error', message])
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>